import { Fragment } from 'react';
import { TickIcon } from '@root/styles/icons';

import {
  ConnectingLine,
  CurrentStepIndicator,
  StepContainer,
  StepIcon,
  StepStage,
} from './DisplayCurrentStep.styles';
import { StepType } from '../../types';

export const DisplayCurrentStep = ({
  steps,
  currentStep,
}: {
  steps: StepType[];
  currentStep: string;
}): JSX.Element => {
  function isStepComplete(step: StepType) {
    if (step === 'rooms' && currentStep !== 'rooms') return true;
    if (step.includes('spa') && currentStep === 'tables') return true;
    return false;
  }

  function isCurrentStep(step: StepType) {
    if (step === 'rooms' && currentStep === 'rooms') return true;
    if (step.includes('spa') && currentStep === 'spa') return true;
    if (step === 'dining' && currentStep === 'tables') return true;
    return false;
  }

  return (
    <StepContainer>
      {steps.map((step, index) => (
        <Fragment key={index}>
          {index === steps.length - 1 && <ConnectingLine />}
          <StepStage key={step}>
            <StepIcon>
              {isStepComplete(step) && <TickIcon />}
              {isCurrentStep(step) && <CurrentStepIndicator />}
            </StepIcon>
            <div>{step}</div>
          </StepStage>
          {index === 0 && <ConnectingLine />}
        </Fragment>
      ))}
    </StepContainer>
  );
};
